/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Share_CreatedInputs */

const en_share_created = /** @type {(inputs: Share_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created on ${i?.date}`)
};

const de_share_created = /** @type {(inputs: Share_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erstellt am ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Created on {date}" |
*
* @param {Share_CreatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const share_created = /** @type {((inputs: Share_CreatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_CreatedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_share_created(inputs)
	return en_share_created(inputs)
});